<div class="user-data-dropdown">
  <div
    class="togglable-input"
    (click)="toggle()"
    (keydown.space)="toggle()"
    (keydown.enter)="toggle()"
    tabindex="0"
  >
    <div class="dropdown-header">
      {{ header }}
    </div>
    <div class="icon-container">
      <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
    </div>
  </div>

  <div class="content-container " [ngClass]="{ 'content-container--phone-toggled': toggled }">
    <ng-content></ng-content>
  </div>
</div>